import { http } from "../../../services/apiUserAd/Http.interceptor";


export const getUserById = (id: string) => {
    return http.get(`/find_user/${id}`);
}


export const getUserByName = (name: string) => {
    return http.get(`/find_all/${name}`);
}